export const infoBlocksData = [
  {
    id: '1',
    icon: '👥',
    title: '30 000+ продажів наших чохлів',
    description: 'Більше 30 тисяч задоволених клієнтів обирають наші товари',
  },
  {
    id: '2',
    icon: '🏆',
    title: 'Гарантія 90 днів',
    description: 'Ми гарантуємо якість чохлів протягом 90 днів після покупки',
  },
  {
    id: '3',
    icon: '🎨',
    title: 'Персоналізація чохлів',
    description: 'Унікальна можливість створити дизайн чохла на ваш смак',
  },
  {
    id: '4',
    icon: '🚚',
    title: 'Відправка за 1 день',
    description: 'Швидке відправлення вашого замовлення в день оформлення',
  },
  {
    id: '5',
    icon: '🇺🇦',
    title: 'Зроблено в Україні',
    description: 'Високоякісна продукція вітчизняного виробництва',
  },
  {
    id: '6',
    icon: '✨',
    title: '2000+ унікальних дизайнів',
    description: 'Величезний вибір креативних та унікальних рішень',
  },
];
